import React from 'react'
import { Outlet } from 'react-router-dom'
import AdminLgBar from './components/AdminLgBar'


function AdminDash() {
  return (
    <div>
      <AdminLgBar />
      <Outlet />
    </div>
  )
}

export default AdminDash
